import React from 'react';
import CarouselManager from '@/components/admin/carousel/CarouselManager';
import AvatarCleanupTool from '@/components/admin/utils/AvatarCleanupTool';

const AdminImages = () => {
  return (
    <div className="container mx-auto p-6">
      <h1 className="text-2xl font-bold mb-6">Image Management</h1>
      
      <div className="grid gap-6">
        <CarouselManager />
        
        <div className="grid gap-6 md:grid-cols-2">
          <AvatarCleanupTool />
          
          <div className="p-4 border rounded-lg opacity-50">
            <h3 className="text-lg font-medium mb-4">More image tools coming soon...</h3>
            <p>We are developing additional image management tools. Please stay tuned.</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminImages;